import { TextUtilities } from '@pwc/pwc-deals-web-common';

const loggedInUserMapper = {
  map: (jwtToken) => {
    if (!jwtToken) return {};

    return {
      initials: TextUtilities.getUserInitials(
        jwtToken.given_name,
        jwtToken.family_name
      ),
      givenName: jwtToken.given_name,
      familyName: jwtToken.family_name,
      name: `${jwtToken.given_name} ${jwtToken.family_name}`,
    };
  },
};

export default loggedInUserMapper;
